import { Inbox } from 'lucide-react';
import styles from './EmptyState.module.css';

export default function EmptyState({ icon: Icon = Inbox, title, description, action }) {
  return (
    <div className={styles.wrap}>
      <Icon size={34} className={styles.icon} />
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className={styles.desc}>{description}</div>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
